"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IFrameWidgetBuilder = void 0;
var IFrameWidget_1 = __importDefault(require("../Widgets/IFrameWidget"));
var IFrameOgBuilder_1 = __importDefault(require("../IIFrameBuilder/IFrameOgBuilder"));
var OpenGraphProvider_1 = __importDefault(require("../OpenGraphProvider/OpenGraphProvider"));
/**
 * Esta clase lo que hace es isertar en todos tags
 * con clases de bp-comments o bp-buttons el iframe
 *  para pintar los comentarios o el botón
 */
var IFrameWidgetBuilder = /** @class */ (function () {
    function IFrameWidgetBuilder() {
    }
    /**
     * Build all
     */
    IFrameWidgetBuilder.build = function (parser, params) {
        return this.buildElements(parser, params);
    };
    /**
     * Render comment iframes
     */
    IFrameWidgetBuilder.buildElements = function (parser, params) {
        var configs = parser.parse();
        var widgets = configs.map(function (config) {
            return new IFrameWidget_1.default(config, new IFrameOgBuilder_1.default(new OpenGraphProvider_1.default()).build(config));
        });
        return widgets;
    };
    return IFrameWidgetBuilder;
}());
exports.IFrameWidgetBuilder = IFrameWidgetBuilder;
exports.default = IFrameWidgetBuilder;
